import React, { Component } from 'react';
import { graphql } from 'react-apollo';
import { flowRight as compose } from 'lodash';
import PropTypes from 'prop-types';
import withStyles from 'isomorphic-style-loader/withStyles';
import { FormattedMessage } from 'react-intl';
import cx from 'classnames';

import s from './EditLocation.css';
import messages from '../../../locale/messages';
import Loader from '../../../components/Common/Loader/Loader';
import LocationForm from '../../../components/SiteAdmin/Location/LocationForm/LocationForm';
import getLocationQuery from './getLocation.graphql';

class EditLocation extends Component {
    static propTypes = {
        id: PropTypes.number.isRequired,
    };

    render() {
        const { data: { loading, getLocation }, id } = this.props;

        let initialValues = {};

        if (!loading && getLocation && getLocation.result) {
            const loc = getLocation.result;
            initialValues = {
                locationName: loc.locationName,
                coordinates: loc.coordinates,
                description: loc.description,
                isActive: String(loc.isActive),
                restrictDropOff: String(loc.restrictDropOff),
            };
        }

        return (
            <Loader type={"page"} show={loading}>
                <div>
                    <div className={cx('heading', 'textAlignRightRTL')}>
                        <FormattedMessage {...messages.editLocationHeading} />
                    </div>
                    <div>
                        {!loading && (
                            <LocationForm initialValues={initialValues} id={id} />
                        )}
                    </div>
                </div>
            </Loader>
        );
    }
}

export default compose(
    withStyles(s),
    graphql(getLocationQuery, {
        options: (props) => ({
            variables: { id: props.id },
            fetchPolicy: 'network-only',
        }),
    })
)(EditLocation);
